// TODO: Long-term we probably want a number of different constants files

export const PARTNER_IDS = {
  PAYPAL_GIVES: 53,
  F5: 87,
} as const;

export const PLAN_NAMES = {
  TRANSFORM: 'transform',
} as const;

export const PLAN_PARTNER_NAMES = {
  F5: 'F5',
} as const;

export const COHORT_NAMES = {
  WAVE_2: 'Wave 2',
  EVERGREEN: 'Evergreen',
} as const;
